import { useMemo } from 'react';
import { useNotification } from '../components/NotificationProvider';

export const useCheckNewConnection = () => {
  const { notificationData } = useNotification();

  return useMemo(
    () => !!notificationData.newConnection?.connection,
    [notificationData],
  );
};
